import { useTranslation } from 'react-i18next';
import { PostModal } from '../shared';
import { Template, TemplatePostDetailsType } from './template';

export type InstagramAmbassadorPostDetailsModalProps = Pick<
  React.ComponentProps<typeof PostModal<TemplatePostDetailsType>>,
  'posts'
>;

export const InstagramAmbassadorPostDetailsModal = ({ posts }: InstagramAmbassadorPostDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template />
    </PostModal>
  );
};
